module.exports = {
  "country": "CY",
  "artist": "Eleni Foureira",
  "song": "Fuego",
  "year": "2018",
  "place": "2",
  "spotify": "4TwWOcvjY1qt3QJvtveAGm"
};